import type { IDatePickerControl } from 'src/types/common';

import { useCallback, useState } from 'react';

import { fDateRangeShortLabel } from 'src/utils/format-time';

// ----------------------------------------------------------------------

export type UseDatePickerReturn = {
  selectedDate: IDatePickerControl;
  onChangeSelectedDate: (newValue: IDatePickerControl) => void;
  /********/
  open: boolean;
  onOpen?: () => void;
  onClose: () => void;
  onReset?: () => void;
  label?: string;
  shortLabel?: string;
  /********/
  variant?: 'calendar' | 'input';
  /********/
  setSelectedDate?: React.Dispatch<React.SetStateAction<IDatePickerControl>>;
};

export function useDatePicker(
  start: IDatePickerControl,
  end: IDatePickerControl
): UseDatePickerReturn {
  const [open, setOpen] = useState(false);

  const [endDate, setEndDate] = useState(end as IDatePickerControl);
  const [selectedDate, setSelectedDate] = useState(start as IDatePickerControl);

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const onChangeSelectedDate = useCallback((newValue: IDatePickerControl) => {
    setSelectedDate(newValue);
  }, []);

  const onReset = useCallback(() => {
    setSelectedDate(null);
    setEndDate(null);
  }, []);

  return {
    selectedDate: selectedDate as IDatePickerControl,
    onChangeSelectedDate,
    /********/
    open,
    onOpen,
    onClose,
    onReset,
    label: fDateRangeShortLabel(selectedDate, endDate, true),
    shortLabel: fDateRangeShortLabel(selectedDate, endDate),
    /********/
    setSelectedDate,
  };
}
